import Hero from '@global/Blocks/Hero'
import Text from '@global/Blocks/Text'
import TwinEqualCTA from '@global/Blocks/TwinEqualCTA'
import Breadcrumbs from '@global/Breadcrumbs'
import LoadmoreInfo from '@global/SearchResults/LoadmoreInfo'
import { Section } from '@styles/global.styled'
import { NextSeo } from 'next-seo'
import { useState } from 'react'
import WagtailBlocksSection from '../components/global/Blocks/WagtailBlocksSection'
import { getChildPages } from '../lib/api-services/cmsService'
import { apiFieldsQuery, defaultImages } from '../lib/variables'

const RegionIndexPage = ({
  regionsData,
  pageData: { id, title, preamble, meta, content_blocks, hero_image },
}) => {
  const [regions, setRegions] = useState({
    ...regionsData,
  })
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 12,
  })

  const getRegions = async (params) => {
    const page = params.page || 1
    const limit = params.limit || 12
    const offset = (page - 1) * limit

    let nQueryParams = { ...params, page, limit, offset }
    setQueryParams({ ...nQueryParams })

    const resp = await getChildPages(
      'suburbs.RegionPage',
      id,
      null,
      null,
      nQueryParams,
      apiFieldsQuery.RegionPage
    )

    const data = {
      ...resp,
      items: resp.items
        ? resp.items.map((item) => ({
            title: item.title,
            image: item?.hero_image_small?.url,
            url: item.meta.path,
          }))
        : [],
    }

    return data
  }

  const defaultTitle = `${title} Property Market & Municipalities Guide | Barry Plant`
  const defaultDescription = `Explore the vast ${title} property market. Our comprehensive guide provides detailed insights and links to individual municipalities, helping you find the perfect real estate opportunities across the region.`
  const metaTitle = meta.meta_title || defaultTitle
  const metaDescription = meta.meta_description || defaultDescription || ''
  const ogTitle = meta.og_title || metaTitle
  const ogImage = meta.og_img
    ? [{ url: meta.og_img }]
    : hero_image?.url
    ? [{ url: hero_image?.url }]
    : [{ url: defaultImages.mediumNavy }]
  const ogDescription = meta.og_description || metaDescription

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          images: ogImage,
          title: ogTitle,
          description: ogDescription,
          type: 'website',
        }}
      />
      <Hero
        title={`Explore the ${title} Property Market`}
        breadcrumbs={
          <Breadcrumbs
            secondary
            breadcrumbs={[
              { label: 'Suburb Profiles', url: '/suburb-profile' },
              { label: title, url: '#' },
            ]}
          />
        }
        bgImageUrl={hero_image?.url}
      />
      {!!preamble && (
        <Section withPaddingBottom>
          <Text content={preamble} />
        </Section>
      )}
      <Section noPaddingTop>
        <TwinEqualCTA
          title={regions.title}
          items={regions.items.map((item) => ({
            ...item,
            description: '',
          }))}
          itemBackground='white'
          numberOfItems={3}
          size='sm'
          loadMoreButton={
            <LoadmoreInfo
              noMarginBottom
              total={regions.total}
              numberShowing={regions.items?.length || 0}
              queryParams={queryParams}
              apiCall={getRegions}
              page={queryParams.page}
              onSuccess={(data) => {
                setRegions((prev) => ({
                  ...prev,
                  items: prev.items.concat(data),
                }))
              }}
            />
          }
        />
      </Section>
      <WagtailBlocksSection blocks={content_blocks} />
    </>
  )
}

RegionIndexPage.getInitialProps = async (ctx, pageData) => {
  let childrenPages = await getChildPages(
    'suburbs.RegionPage',
    pageData.id,
    null,
    null,
    { limit: 12 },
    apiFieldsQuery.RegionPage
  )

  return {
    regionsData: {
      total: childrenPages.meta.total_count,
      title: `${pageData.title} Municipalities`,
      items:
        childrenPages.items?.map((item) => {
          return {
            title: item.title,
            image: item?.hero_image_small?.url,
            url: item.meta.path,
          }
        }) ?? [],
    },
  }
}
export default RegionIndexPage
